import * as React from 'react';
import classnames from 'classnames';
import {IPropsInjectedByViewerScript, IProductWidgetSantaProps} from '../../types/app-types';
import s from './ProductWidgetApp.scss';
import {ProductWidgetLayout} from '../ProductWidgetLayout/ProductWidgetLayout';
import {IProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import '../../styles/app.global.scss';
import {
  withTranslations,
  IProvidedTranslationProps,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {getProductWidgetSettingsFromProps} from '../../commons/styleParamsService';
import {TPAComponentsProvider} from '@wix/wix-ui-tpa';
import {NoProduct} from '../../icons/dist';

export type IProductWidgetAppProps = IPropsInjectedByViewerScript &
  IProvidedGlobalProps &
  IProductWidgetSantaProps &
  IProvidedTranslationProps;

export enum DataHook {
  Root = 'product-widget',
  EmptyState = 'empty-state',
  EmptyStateText = 'empty-state-text',
}

class ProductWidget extends React.Component<IProductWidgetAppProps> {
  public componentDidMount(): void {
    this.props.host.registerToComponentDidLayout(this.reportAppLoaded);
  }

  public componentDidUpdate(prevProps: IProductWidgetAppProps): void {
    const productWidgetPrevProps = getProductWidgetSettingsFromProps(prevProps);
    const productWidgetProps = getProductWidgetSettingsFromProps(this.props);
    if (this.props.host.viewMode === 'Editor' && productWidgetPrevProps.fullWidth && !productWidgetProps.fullWidth) {
      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.props.host.resizeComponent({width: 940, height: 400});
      }, 1000);
    }
  }

  private readonly reportAppLoaded = () => {
    this.safeRun(this.props.onAppLoaded);
  };

  private safeRun(fn) {
    if (this.props.globals.isInteractive && typeof fn === 'function') {
      fn();
    }
  }

  private get isReady() {
    return this.props.globals.product !== undefined;
  }

  public render(): React.ReactNode {
    const {
      horizontalLayout,
      dimensions: {height, width},
      isMobile,
      isRTL,
    } = this.props.globals;
    const {emptyState, t} = this.props;

    if (!this.isReady) {
      return null;
    }

    return (
      <TPAComponentsProvider value={{mobile: isMobile, rtl: isRTL}}>
        <section
          style={{width, height}}
          data-hook={DataHook.Root}
          className={classnames(s.productWidgetApp, {
            [s.horizontal]: horizontalLayout,
          })}>
          {emptyState ? (
            <section className={s.emptyState} data-hook={DataHook.EmptyState}>
              <NoProduct />
              <p data-hook={DataHook.EmptyStateText}>{t('EMPTY_STATE')}</p>
            </section>
          ) : (
            <ProductWidgetLayout />
          )}
        </section>
      </TPAComponentsProvider>
    );
  }
}

export const ProductWidgetApp = withGlobalProps(withTranslations('globals.texts')(ProductWidget));
